const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/LoginPage/LoginSteps.tsx';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { createSelector } from 'reselect';
import { Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import { FormContent } from './FormContent/FormContent';
import { LoginState } from 'App/defs/loginDefs';
import { useEffect, useState } from 'react';
import { GapBig } from 'App/components/Gap/Gap';
import textMap from 'App/pages/LoginPage/translations';
import { loginFormWrapper, loginStepsStyleWrapper, loginStepsStyleWrapperSmDevices } from './styles';
import { LoginStage } from 'App/pages';
import useBreakpoint from '@cistec/common_web/hooks/useBreakpoint';
import { useTheme } from '@mui/material/styles';
import { goToDashboard } from 'App/utils/history';
import { attemptsLeft, codeCreationDate, codeLifeTime, loginError, loginState, phoneNumber } from 'App/store/login';

export interface LoginData {
    loginState: string;
    loginPhone: string;
    loginError: string;
    loginAttemptsLeft: number;
    loginCodeCreationDate: string;
    codeLifeTime: number;
}

/**
 * Reselect selector
 */
const formData = createSelector(
    [loginState, phoneNumber, loginError, attemptsLeft, codeCreationDate, codeLifeTime],
    (
        loginState: string,
        loginPhone: string,
        loginError: string,
        loginAttemptsLeft: number,
        loginCodeCreationDate: string,
        codeLifeTime: number
    ): LoginData => {
        return {
            loginState,
            loginPhone,
            loginError,
            loginAttemptsLeft,
            loginCodeCreationDate,
            codeLifeTime,
        };
    }
);

interface Props {
    prefillInvitationCode: string | undefined;
}

export const LoginSteps = (props: Props) => {
    const theme = useTheme();
    const isSmallDevice = useBreakpoint(theme?.breakpoints?.values?.sm);

    const loginData = useSelector(formData);
    const [wasSMSSending, setWasSMSSending] = useState(false);
    const [wasSMSVerifying, setWasSMSVerifying] = useState(false);
    const [stage, setStage] = useState<LoginStage>('invitation-code');
    const history = useHistory();
    const { formatMessage } = useIntl();
    const isWaiting =
        loginData.loginState === LoginState.SENDING_SMS_FROM_INVITATION ||
        loginData.loginState === LoginState.VERIFYING_SMSCODE;
    const hasFailed =
        loginData.loginState === LoginState.SEND_SMS_FAILED ||
        loginData.loginState === LoginState.VERIFY_SMSCODE_FAILED;

    const text = formatMessage(
        stage === 'invitation-code' ? textMap.messageOnStageInvitationCode : textMap.messageOnStageSMSCode
    ).replace('(###FON###)', loginData.loginPhone);

    useEffect(() => {
        loginData.loginState === LoginState.SENDING_SMS_FROM_INVITATION && setWasSMSSending(true);
        if (wasSMSSending && loginData.loginState === LoginState.SMS_SENT) {
            setStage('sms-code');
        } else {
            loginData.loginState === LoginState.VERIFYING_SMSCODE && setWasSMSVerifying(true);
            if (wasSMSVerifying && loginData.loginState === LoginState.GOT_TOKEN) {
                goToDashboard(history);
            }
        }
    }, [loginData]);
    return (
        <>
            <div className={isSmallDevice ? loginStepsStyleWrapperSmDevices : loginStepsStyleWrapper}>
                {!isSmallDevice && <GapBig />}
                <Typography variant={'body1'}>{text}</Typography>
                <div className={loginFormWrapper}>
                    <FormContent
                        stage={stage}
                        prefillInvitationCode={props.prefillInvitationCode}
                        isActive={!isWaiting}
                        isLoading={isWaiting}
                        loginError={!hasFailed ? undefined : loginData.loginError}
                        setStage={setStage}
                        loginData={loginData}
                    />
                </div>
            </div>
        </>
    );
};
